export class SecuritySettings {

  public wordpressVulnerabilities: boolean;
  public pluginsVulnerabilities: boolean;
  public coreFilesChanges: boolean;
  public pluginFilesChanges: boolean;
  public themeFilesChanges: boolean;

}
